/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class ExternalApiService extends DataService<Wars.Domain.Model.ProcessConfiguration>{

        constructor(breeze: any, $q: angular.IQService, private $http: angular.IHttpService) {
            super(breeze, $q);
        }

        public getExternalApiConfiguration(processConfigId: string): angular.IPromise<Wars.Domain.Model.ProcessConfiguration> {
            var expand = "myProcessType, " +
                "myExternalApiConfiguration.myStatusMappings.statusCode, " +
                "myExternalApiConfiguration.myStatusMappings.myStateMappings.stateCode, " +
                "myExternalApiConfiguration.myFormMappings.myListMappings.myPropertyMappings, " +
                "myExternalApiConfiguration.myFormMappings.myListMappings.myPropertyMappings.schemaProperty, " +
                "myExternalApiConfiguration.myFormMappings.myListMappings.objectSchema, " +
                "myExternalApiConfiguration.myFormMappings.myPropertyMappings.schemaProperty, " +
                "myExternalApiConfiguration.myProcessDataMapping.myPropertyMappings.schemaProperty, " +
                "myExternalApiConfiguration.myProcessDataMapping.myListMappings.objectSchema, " +
                "myExternalApiConfiguration.myProcessDataMapping.myListMappings.myPropertyMappings.schemaProperty, " +
                "myExternalApiConfiguration.myReviewMappings.reviewConfiguration";

            const query = this.breezeModule.EntityQuery
                .from("ProcessConfigurationsLazy")
                .where('id', '==', processConfigId)
                .expand(expand);

            return this.fetch(query);
        }

        public updateAllMappings(processConfigId: string): angular.IPromise<boolean> {
            var params = {};
            var handlerUrl = "api/ExternalApi/UpdateAllMappings/" + processConfigId;

            var result: ng.IPromise<any> = this.$http.post(handlerUrl, params)
                .then((response: any): ng.IPromise<any> => this.handlerResponded(response, params));

            return result;
        }
    }
}

warsApp.registerService('ExternalApiService', ['breeze', '$q', '$http']);
